import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { MEM_BY_PLAN_YEAR_ALL } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        MSIID: '',
        MemberID: '',
        Carrier: '',
        PlanType: '',
        Account: '',
        Group: '',
        StartDate: '',
        EndDate: '',
        ChangeDate: '',
        PlanYear: '',
        EndDateForPlanYear: '',
        RowNum: '',
        Sequence: '',
        MBIPYPTRank: '',
        MCPYTRANK: '',
        MCAPYPTRANK: '',
        MCAGPYPTRANK: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "MSI ID",
        collectionName: "Plan Year All"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        MSIID: false,
        Account: false,
        Group: false,
        MemberID: false,
        Carrier: false,
    }
}

export const getMemberByPlanYearData = createAsyncThunk('data/getMemberByPlanYearData',
    async (data, { rejectWithValue }) => {
        try {
            let queryByPlanYear =
                `query GetMemberPlanYearAllDetails{
                GetMemberPlanYearAllDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"Plan Year All"
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.MSIID ? `,msiID: "${data.MSIID}"` : ""}
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.MemberID ? `,member: "${data.MemberID}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                `;

            queryByPlanYear += MEM_BY_PLAN_YEAR_ALL

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryByPlanYear, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getMemberByPlanYearDataDownloadAll = createAsyncThunk('data/getMemberByPlanYearDataDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryByPlanYear =
                `query GetAllMemberPlanYearAllDetails{
                    GetAllMemberPlanYearAllDetails(
                collectionName:"Plan Year All",
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.MSIID ? `,msiID: "${data.MSIID}"` : ""}
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.MemberID ? `,member: "${data.MemberID}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                `;

            queryByPlanYear += MEM_BY_PLAN_YEAR_ALL

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryByPlanYear, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const memberByPlanYearSlice = createSlice({
    name: 'memberByPlanYear',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMemberByPlanYearData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getMemberByPlanYearData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetMemberPlanYearAllDetails.totalCount;
                state.data.tableData = response.data.data.GetMemberPlanYearAllDetails.data;
            })
            .addCase(getMemberByPlanYearData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getMemberByPlanYearDataDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getMemberByPlanYearDataDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                //state.data.totalCount = response.data.data.GetMemberPlanYearAllDetails.totalCount;
                state.data.tableData = response.data.data.GetAllMemberPlanYearAllDetails.data;
            })
            .addCase(getMemberByPlanYearDataDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = memberByPlanYearSlice.actions;
export default memberByPlanYearSlice.reducer